import React, {useEffect, useRef, useState} from 'react';
import { useHistory } from 'react-router-dom';
import {AppBar, CircularProgress, Tab, Tabs} from '@mui/material';
import {withStyles} from "@mui/styles";
import {
  getOrganisations,
} from "../../utils/api";
import PropTypes from "prop-types";
import OrganisationDashboard from "./OrganisationDashboard";
import ClusterDashboard from "./OverallDashboard";

const styles = (theme) => ({
  paper: {
    padding: 15,
    marginTop: 10
  },
  main: {
    flex: 1,
    padding: theme.spacing(3, 3),
    background: '#eaeff1',
  },
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          style={{height: '100%'}}
          {...other}
      >
        {value === index && (
            <div style={{height: '100%'}}>{children}</div>
        )}
      </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Dashboard(props) {
  const { classes, org } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isForbidden, setIsForbidden] = useState(false);
  const [organisations, setOrganisations] = useState([]);
  const [value, setValue] = useState(0);

  const cancelRequest = useRef();
  let history = useHistory();

  const handleTabChange = (event, newValue) => {
    history.push(`/dashboard/${newValue}`);
    setValue(newValue);
  };

  const fetchOrganisations = async (loading) => {
    setIsError(false);
    setIsLoading(loading);
    try {
      const result = await getOrganisations();
      const orgData = result.data;

      if (!cancelRequest.current) {
        if (orgData && Object.keys(orgData).length > 0) {
          setOrganisations(orgData);
          setIsLoading(false);
        } else {
          setIsError(true);
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setIsForbidden(true);
      } else if (!cancelRequest.current) {
        setIsError(true);
      }
    }
  };

  useEffect(() => {
    fetchOrganisations(true);
    setValue(org ? parseInt(org.split('_').pop()) : 0);
    history.push(`/dashboard/${org ? parseInt(org.split('_').pop()) : 0}`);
  }, [org]);

  const renderData = () => {
    if (isError) {
      return (
          <>
            Error
          </>
      );
    }

    if (isForbidden) {
      return (
          <>
            Access denied!
          </>
      );
    }

    if (isLoading) {
      return (
          <>
            <div style={{width: '100%', textAlign: 'center', height: '100%'}}>
              <CircularProgress style={{marginTop: '10%'}} color="primary" />
            </div>
          </>
      );
    }

    return (
        <>
          <AppBar
              component="div"
              className={classes.appBar}
              color="primary"
              position="static"
              elevation={5}
          >
            <Tabs textColor={'#fff'} TabIndicatorProps={{style: {background:'white'}}}  value={value} onChange={handleTabChange}>
              <Tab style={{fontSize: 14, fontWeight: "normal"}} label={'Overall'} {...a11yProps(0)}/>
              { organisations.map((organisation) => (
                  <Tab  style={{fontSize: 14, fontWeight: "normal"}} label={organisation.name} value={organisation.id} {...a11yProps(organisation.id)}/>
              ))}
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <main className={classes.main}>
              <ClusterDashboard />
            </main>
          </TabPanel>
          { organisations.map((organisation) => (
              <TabPanel key={organisation.id} value={value} index={organisation.id}>
                <main className={classes.main}>
                  <OrganisationDashboard org={organisation} />
                </main>
              </TabPanel>
          ))}
        </>

    );
  };

  return renderData();
}

export default withStyles(styles)(Dashboard);